import { render, staticRenderFns } from "./BlockTypeQuizAndReview.vue?vue&type=template&id=297f97b0&scoped=true&"
import script from "./BlockTypeQuizAndReview.vue?vue&type=script&lang=js&"
export * from "./BlockTypeQuizAndReview.vue?vue&type=script&lang=js&"
import style0 from "./BlockTypeQuizAndReview.vue?vue&type=style&index=0&id=297f97b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297f97b0",
  null
  
)

export default component.exports